module.exports = __webpack_public_path__ + "static/imi-map-ac921d725262e7379f003d64cf60ba3c.png";